"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateToV3 = void 0;
var lodash_1 = require("lodash");
var versions_1 = require("@wix/wix-vod-constants/dist/app-settings/versions");
/* Don't change settings here! To change settings behavior, create new version */
/* This version includes addition of language parameter */
function migrateToV3(appSettingsV2) {
    return (0, lodash_1.merge)({}, appSettingsV2, {
        numbers: {
            settingsVersion: versions_1.APP_SETTINGS_VERSION_3,
        },
        fonts: {
            language: '',
        },
    });
}
exports.migrateToV3 = migrateToV3;
//# sourceMappingURL=version-3.js.map